<template>
  <footer class="footer pt-5 pb-5">
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="3">
          <div class="mb-4">
            <div
              class="text-subtitle-1"
              v-text="'OUR COMPANY'"
            ></div>
          </div>
          <div class="footer-links">
            <a href="https://routeline.com/pages/career" class="footer-link">
              <div class="link-bullet"></div>
              Career
            </a>
            <a href="https://routeline.com/pages/membership-overview" class="footer-link">
              <div class="link-bullet"></div>
              Membership
            </a>
            <a href="https://routeline.com/pages/about" class="footer-link">
              <div class="link-bullet"></div>
              About-us
            </a>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <div class="mb-4">
            <div
              class="text-subtitle-1"
              v-text="'CUSTOMER SERVICE'"
            ></div>
          </div>
          <div class="footer-links">
            <a href="https://routeline.com/pages/contact" class="footer-link">
              <div class="link-bullet"></div>
              Contact us
            </a>
            <a href="https://routeline.helpscoutdocs.com/" class="footer-link">
              <div class="link-bullet"></div>
              Frequently Asked
            </a>
            <a href="https://routeline.com/policies/privacy-policy" class="footer-link">
              <div class="link-bullet"></div>
              Privacy Policy
            </a>
            <a href="https://routeline.com/policies/terms-of-service" class="footer-link">
              <div class="link-bullet"></div>
              Terms of Service
            </a>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <div class="mb-4">
            <div
              class="text-subtitle-1"
              v-text="'SIGN UP AND SAVE'"
            ></div>
          </div>
          <div class="text-subtitle-1 mb-4" v-text="'Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.'"></div>
          <div class="footer-links">
            <!-- <router-link :to="'/about'" class="footer-link">
              <div class="link-bullet"></div>
              about routeline
            </router-link>
            <router-link :to="'/mission'" class="footer-link">
              <div class="link-bullet"></div>
              our mission & strategy
            </router-link>
            <router-link :to="'/vision'" class="footer-link">
              <div class="link-bullet"></div>
              out vision
            </router-link>
            <router-link :to="'/advantages'" class="footer-link">
              <div class="link-bullet"></div>
              routeline advantages
            </router-link>
            <router-link :to="'/contact'" class="footer-link">
              <div class="link-bullet"></div>
              contact us
            </router-link> -->
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <div
            class="text-h6 mb-4"
          >
            <img src="@/assets/logo.png" alt="" class="footer-logo">
          </div>
          <div class="footer-links d-flex">
            <a href="https://business.facebook.com/RouteLineCo" class="footer-link mr-2">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/routelineco" class="footer-link mr-2">
              <i class="fa fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@routelineco" class="footer-link mr-2">
              <img src="@/assets/tiktok.svg" style="width: 16px" alt="">
            </a>
            <a href="https://www.youtube.com/channel/UCCoVUtIsuleNBtfCxnHvkWw" class="footer-link">
              <i class="fa fa-youtube"></i>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({})
</script>

<style scoped lang="scss">
.footer {
  background-color: var(--primary-color);

  &-image {
    width: 120px;
  }
  &-link {
    color: var(--white);
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize;
    text-decoration: none;
    display: block;
    margin: 5px 0;
    transition: all 0.3s ease;
    &:hover {
      color: var(--white);
      // transform: translateX(7px);
    }
  }
  &-logo {
    width: 150px;
  }
}
.text-subtitle-1, .text-h6 {
  color: var(--white);
}
.text-subtitle-2 {
  color: var(--white);
}
</style>
